import z from 'zod';
import {jobStatusSchema} from './JobStatus';
import {jobTypeSchema} from './JobType';

/**
 * Document shape as stored in Firestore (jobs / jobsDev).
 * id comes from document id when reading.
 */
export const jobWriteSchema = z.object({
  type: jobTypeSchema,
  status: jobStatusSchema,
  title: z.string(),
  description: z.string().optional(),
  data: z.string().optional(),
  messages: z.array(z.string()).optional(),
  progress: z.number().min(0).max(100).optional(),
  createdBy: z.string(),
  metadata: z.record(z.string(), z.any()).optional(),
});

export interface JobWrite extends z.infer<typeof jobWriteSchema> {}
